import { render } from "./CashboxTransactionModal.vue?vue&type=template&id=4bd5ea1a&scoped=true"
import script from "./CashboxTransactionModal.vue?vue&type=script&lang=js"
export * from "./CashboxTransactionModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd5ea1a"]])

export default __exports__